/**
 * An API client for the non-submission related AJAX calls,
 * like fetching suppliers, tariffs, addresses or sending reminders
 * @module embed/api
 */
import { send } from '@/lib/xhr';

const PATH_SUPPLIERS = 'switch/suppliers.json';
const PATH_TARIFF = 'switch/tariffs.json';
const PATH_ADDRESSES = 'switch/addresses.json';
const PATH_REMINDER = 'submissions/:submission_id/reminders';

// Sets the default base URL for the API
// to the root of the current domain
// TODO: Probably remove or set to `/` as an absolute path should already
// take care of that
const DEFAULT_BASE_URL = (function() {
  const a = document.createElement('a');
  a.href = '/';
  return a.href;
})();

/** */
export default class APIClient {
  /** */
  constructor(baseUrl) {
    this.baseUrl = baseUrl || DEFAULT_BASE_URL;
  }
  /** */
  getSupplierList(options) {
    const url = this.url(PATH_SUPPLIERS, options);
    return (
      send(url, { withCredentials: true, responseType: 'json' })
        .catch(e => {
          if (
            e.target.status == 422 &&
            e.target.parsedResponse.type == 'postcode_not_switchable'
          ) {
            throw new Error('postcode_not_switchable');
          }
          throw e;
        })
        .then(e => e.target.parsedResponse.suppliers || [])
        // The API returns objects instead of arrays when empty...
        .then(list => (Array.isArray(list) ? list : []))
    );
  }
  /** */
  getTariffList(options) {
    const url = this.url(PATH_TARIFF, options);
    return send(url, { withCredentials: true, responseType: 'json' })
      .catch(e => {
        if (
          e.target.status == 422 &&
          e.target.parsedResponse.type == 'postcode_not_switchable'
        ) {
          throw new Error('postcode_not_switchable');
        }
        throw e;
      })
      .then(e => e.target.parsedResponse.tariffs || [])
      .then(list => (Array.isArray(list) ? list : []));
  }
  /** */
  getAddressList(options) {
    const url = this.url(PATH_ADDRESSES, options);
    return send(url, { withCredentials: true, responseType: 'json' })
      .then(e => e.target.parsedResponse.addresses || [])
      .then(list => (Array.isArray(list) ? list : []));
  }
  /** */
  requestReminder(options) {
    const { submission_id, ...data } = options;
    const url = this.url(
      PATH_REMINDER.replace(':submission_id', submission_id)
    );
    return send(url, {
      withCredentials: true,
      method: 'POST',
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(data)
    });
  }
  /** */
  url(path, params) {
    const url = new URL(this.baseUrl + path);
    if (params) {
      Object.entries(this.encode(params)).forEach(([name, value]) =>
        url.searchParams.append(name, value)
      );
    }
    return url;
  }
  /** */
  encode({ economy7, dual_fuel, fuel_type, ...otherParams }) {
    return {
      ...otherParams,
      // Ensure boolean values are sent for economy7 and dual_fuel values
      economy7: !!economy7,
      dual_fuel: !!dual_fuel,
      // Ensure fuelType is dual if dual_fuel is set
      fuel_type: dual_fuel ? 'dual' : fuel_type
    };
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/api.js